/**
 * room-landing.js
 * Interactive behaviours for the Room Landing v3 section:
 * 1. Collection tab switching — AJAX product loading via pill tabs
 * 2. Pill tab horizontal scroll arrows
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    var sections = document.querySelectorAll('[data-collection-tabs]');
    sections.forEach(initCollectionTabs);

    function initCollectionTabs(section) {
      var pills = section.querySelectorAll('[data-tab-pill]');
      var grid = section.querySelector('[data-product-grid]');
      var viewAllPill = section.querySelector('[data-view-all-pill]');
      var pillContainer = section.querySelector('[data-pill-container]');
      var prevBtn = section.querySelector('[data-pill-prev]');
      var nextBtn = section.querySelector('[data-pill-next]');
      var productLimit = parseInt(section.getAttribute('data-product-limit'), 10) || 8;
      var loading = false;

      if (!grid || pills.length === 0) return;

      // Pill click handler
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (loading) return;
          var handle = pill.getAttribute('data-collection-handle');
          if (!handle) return;

          // Update active states
          pills.forEach(function (p) {
            p.classList.remove('rl-pill--active');
            p.setAttribute('aria-pressed', 'false');
          });
          pill.classList.add('rl-pill--active');
          pill.setAttribute('aria-pressed', 'true');

          // Update "View all" link
          if (viewAllPill) {
            viewAllPill.href = '/collections/' + handle;
          }

          // Fetch products
          fetchCollection(handle);
        });
      });

      // Scroll arrows
      if (prevBtn && pillContainer) {
        prevBtn.addEventListener('click', function () {
          pillContainer.scrollBy({ left: -150, behavior: 'smooth' });
        });
      }
      if (nextBtn && pillContainer) {
        nextBtn.addEventListener('click', function () {
          pillContainer.scrollBy({ left: 150, behavior: 'smooth' });
        });
      }

      function fetchCollection(handle) {
        loading = true;
        showSkeletons();

        fetch('/collections/' + handle + '/products.json?limit=' + productLimit)
          .then(function (res) {
            if (!res.ok) throw new Error('Failed to fetch collection');
            return res.json();
          })
          .then(function (data) {
            renderProducts(data.products || []);
          })
          .catch(function () {
            grid.innerHTML = '<div class="rl-collection-tabs__empty"><p>Unable to load products. Please try again.</p></div>';
          })
          .finally(function () {
            loading = false;
          });
      }

      function showSkeletons() {
        var skeletonCount = Math.min(productLimit, 5);
        var html = '';
        for (var i = 0; i < skeletonCount; i++) {
          html += '<article class="rl-cpg-card rl-cpg-card--skeleton">' +
            '<div class="rl-cpg-card__image-link"></div>' +
            '<div class="rl-cpg-card__body">' +
            '<div class="rl-skel-line"></div>' +
            '<div class="rl-skel-line rl-skel-line--short"></div>' +
            '<div class="rl-skel-line rl-skel-line--price"></div>' +
            '</div></article>';
        }
        grid.innerHTML = html;
      }

      function renderProducts(products) {
        if (!products.length) {
          grid.innerHTML = '<div class="rl-collection-tabs__empty"><p>No products found in this collection.</p></div>';
          return;
        }

        var html = '';
        var count = Math.min(products.length, productLimit);

        for (var i = 0; i < count; i++) {
          var p = products[i];
          var title = escapeHtml(p.title);
          var url = '/products/' + p.handle;
          var image = p.images && p.images.length > 0 ? p.images[0].src : '';
          var price = p.variants && p.variants[0] ? p.variants[0].price : '0.00';
          var comparePrice = p.variants && p.variants[0] ? p.variants[0].compare_at_price : null;

          html += '<article class="rl-cpg-card">';
          html += '<a class="rl-cpg-card__image-link" href="' + url + '" aria-label="' + title + '">';

          if (image) {
            html += '<img src="' + image + '" alt="' + title + '" width="400" height="400" loading="lazy" class="rl-cpg-card__image">';
          }

          if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
            var save = (parseFloat(comparePrice) - parseFloat(price)).toFixed(2);
            html += '<span class="rl-cpg-card__badge">Save &pound;' + save + '</span>';
          }

          html += '</a>';
          html += '<div class="rl-cpg-card__body">';
          html += '<p class="rl-cpg-card__title">' + title + '</p>';
          html += '<div class="rl-cpg-card__price">';
          html += '<span class="rl-cpg-card__price-current">&pound;' + formatPrice(price) + '</span>';

          if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
            html += '<span class="rl-cpg-card__price-was">&pound;' + formatPrice(comparePrice) + '</span>';
          }

          html += '</div>';
          html += '<span class="rl-cpg-card__vat">INC VAT</span>';
          html += '</div></article>';
        }

        grid.innerHTML = html;
      }

      function formatPrice(price) {
        var num = parseFloat(price);
        return isNaN(num) ? '0.00' : num.toFixed(2);
      }

      function escapeHtml(str) {
        if (!str) return '';
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
      }
    }
  });
})();
